import { Icon } from '@99designs/common/components/Icon';
import { Tooltip } from '@99designs/common/components/Tooltip';
import StockUsageExample from 'launch/components/StockUsageExample';
import stockImageExamples from 'launch/data/stockImageExamples';
import React from 'react';

interface Props {
    categoryKey: string;
}

export default class StockImageExample extends React.Component<Props> {
    render() {
        if (!stockImageExamples[this.props.categoryKey]) {
            return null;
        }

        return (
            <Tooltip
                position={'up-center'}
                tooltip={
                    <StockUsageExample
                        designer={stockImageExamples[this.props.categoryKey]['designer']}
                        designPath={stockImageExamples[this.props.categoryKey]['designPath']}
                        stockPaths={stockImageExamples[this.props.categoryKey]['stockPaths']}
                    />
                }
            >
                <span className="tooltip-trigger">
                    <Icon type={'question-mark-1'} variations={['offset-left']} />
                </span>
            </Tooltip>
        );
    }
}
